import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HouseDetailsComponent } from './houses/house-details.component';
import { ShowcaseDetailsComponent } from './showcases/showcase-details.component';
import { AgencyService, ShowcaseService, PropertyService } from 'api';

const routes: Routes = [
  {
    path: ':agency_uuid/locuinte/:friendly_id',
    component: HouseDetailsComponent,
    resolve: {
      agency: AgencyService,
      property: PropertyService
    }
  },
  {
    path: ':agency_uuid/oferte/:uuid',
    component: ShowcaseDetailsComponent,
    resolve: {
      agency: AgencyService,
      showcase: ShowcaseService
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
